export const StatusVolume = Object.freeze({
  VolumeNegociacao: 1,
  VolumeAceitoParcialmente: 2,
  VolumeRecusado: 3,
  AguardandoInformacoesTransporte: 4,
  VolumeRestanteCancelado: 5,
  VolumeFinalizado: 6,
  VolumeEnviadoParaTransporte: 7
});
